import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  LoadAllJobPositionsForDepartmentAndGroups,
  LoadAllJobPositionsForTenant,
} from 'src/app/competence/state/job-position.actions';
import { JobPositionState } from 'src/app/competence/state/job-position.state';
import { FileType } from 'src/app/crew-management-user/enums/file-type.enum';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';

@Component({
  selector: 'app-print-competence-matrix-dialog',
  templateUrl: './print-competence-matrix-dialog.component.html',
  styleUrls: ['./print-competence-matrix-dialog.component.scss'],
  standalone: false,
})
export class PrintCompetenceMatrixDialogComponent implements OnInit {
  jobPositions$: Observable<IdName[] | undefined>;
  excludedCompetences = new FormControl();
  excludedPositions = new FormControl([]);
  excludedRequirements = new FormControl([]);
  excludedUsers = new FormControl();
  date = new FormControl(new Date());
  fileType = new FormControl(FileType.Pdf);
  requirementTypes = [
    { id: 0, name: 'MANDATORY' },
    { id: 1, name: 'OPTIONAL' },
    { id: 2, name: 'PREFERRED' },
  ];
  formOptions: IdName[] = [
    { id: FileType.Excel, name: FileType.Excel },
    { id: FileType.Pdf, name: FileType.Pdf },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      departmentId: string;
      departmentIds: string[];
      userOptions: IdName[];
      competenceOptions: IdName[];
      date: Date;
      excludedCompetences: string[];
      excludedUsers: string[];
    },
    public dialogRef: MatDialogRef<PrintCompetenceMatrixDialogComponent>,
    private store: Store
  ) {
    this.date.setValue(this.data.date);
    this.excludedCompetences.setValue(this.data.excludedCompetences);
    this.excludedUsers.setValue(this.data.excludedUsers);
  }

  ngOnInit(): void {
    const loadForTenant = !this.data.departmentIds?.length && !this.data.departmentId;
    if (loadForTenant) {
      this.store.dispatch(new LoadAllJobPositionsForTenant(getTenantId()));
      this.jobPositions$ = this.store.select(JobPositionState.getAllJobPositionsForTenant);
    } else {
      this.store.dispatch(
        new LoadAllJobPositionsForDepartmentAndGroups(
          this.data.departmentIds?.length ? this.data.departmentIds : [this.data.departmentId],
          []
        )
      );
      this.jobPositions$ = this.store.select(
        JobPositionState.getJobPositionsForDepartmentAndGroups
      );
    }
  }

  submit(): void {
    const params: any = {
      excludedPositions: this.excludedPositions.value,
      excludedRequirements: this.excludedRequirements.value,
      pivotDate: this.date.value,
      fileType: this.fileType.value,
    };

    if (this.excludedCompetences.value.length) {
      params.excludedCompetences = this.excludedCompetences.value;
    }
    if (this.excludedUsers.value.length) {
      params.excludedUserIds = this.excludedUsers.value;
    }
    this.dialogRef.close(params);
  }
}
